import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Container, Label, ProgressBar, ProgressBarContainer } from './styles';

const ProgressIndicator = ({ progress, label }) => {
  const progressColor = useMemo(() => {
    if (progress > 0 && progress <= 25) {
      return { color: '#CF1322', backgroundColor: '#FFF1F0' };
    }

    if (progress > 25 && progress <= 60) {
      return { color: '#EBAC00', backgroundColor: '#FFFBE6' };
    }

    if (progress > 60) return { color: '#24A95D', backgroundColor: '#EEFFF6' };

    return { color: '#AAAAAA', backgroundColor: '#F5F5F5' };
  }, [progress]);

  return (
    <Container>
      <ProgressBarContainer color={progressColor.backgroundColor}>
        <ProgressBar progress={progress} color={progressColor.color} />
      </ProgressBarContainer>
      {label && <Label>{label}</Label>}
    </Container>
  );
};

ProgressIndicator.propTypes = {
  progress: PropTypes.number,
  label: PropTypes.string,
};

ProgressIndicator.defaultProps = {
  progress: 0,
  label: null,
};

export default ProgressIndicator;
